import { Card, Text } from '@mantine/core'
import React from 'react'

const AnalogDataCard = (props) =>
{
    const { data } = props
    console.log(data)
    return (
        <Card w={'215px'} shadow="sm" p={0} radius={'6px'} style={{ backgroundColor: 'var(--color-white)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', minHeight: '60px' }}>

            <Text size={'1rem'} pl={'1rem'} pr={'0.5rem'} pt={'8px'} weight={500} color='var(--color-bold-text)' style={{ lineHeight: 1.3 }}>{data.name}</Text>

            <Text size={'0.9rem'} pl={'1rem'} pb={'8px'} fw={500} color='var(--color-text)' >{data.value}</Text>

        </Card>
    )
}

export default AnalogDataCard
